import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {TabSelectionService} from '../../../../common/services/tab-selection.service';
import {DataCenterRoutesQueryParam as QueryParam} from '../../../../common/types/routes-query-param.enum';

enum Tab {
  DataCenter,
  DataError,
}

const TabQueryParamByIndexNo = {
  [Tab.DataCenter]: QueryParam.MemberData,
  [Tab.DataError]: QueryParam.ExternalData,
};

@Component({
  selector: 'app-data-center-management-view',
  templateUrl: './data-center-management-view.component.html',
  styleUrls: ['../../../../../../styles/global/_management-styles.scss']
})
export class DataCenterManagementViewComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject();
  activeTabIndex: number;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private tabSelectionService: TabSelectionService,
  ) {
  }

  ngOnInit(): void {
    this.tabSelectionService.currentTab$AsObservable
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((currentTab: string) => {
      this.selectTab(currentTab);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  selectTab(tabName: string): void {
    if (tabName === QueryParam.MemberData) {
      this.activeTabIndex = Tab.DataCenter;
    }
    else if (tabName === QueryParam.ExternalData) {
      this.activeTabIndex = Tab.DataError;
    }
  }

  onTabSelectionChanged($event: MatTabChangeEvent): void {
    this.router.navigate(['/data-center-management'], {
      queryParams: {tab: TabQueryParamByIndexNo[$event.index]},
    });
  }
}
